module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AddNoteView.js"));
	}, "AddNoteView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AddNoteView!./src/pages/Learn/Course/AddNote/AddNoteView.js
// module id = 1235
// module chunks = 431